const ORDER_STATUSES = {
  INITIAL_STATUS: 'QUOTE',
  QUOTE: {
    text: 'Quote',
    color: 'white'
  },
  NEW: {
    text: 'Pending',
    color: 'white'
  },
  IS_PROCESSING: {
    text: 'Is processing',
    color: 'gray'
  },
  WAITING_FOR_PAYMENT: {
    text: 'Is waiting for payment',
    color: '#FFF59D'
  },
  PAIED: {
    text: 'Paid',
    color: 'yellow'
  },
  BUILDING: {
    text: 'Is building',
    color: '#A5D6A7'
  },
  BUILT: {
    text: 'Built',
    color: 'green'
  },
  CANCELED: {
    text: 'Canceled',
    color: 'red'
  },
  UNACTIVE: {
    text: 'UNACTIVE',
    color: 'darkred'
  }
}
export default ORDER_STATUSES
